export const skills = state => state.skills;
